const influencers = {
  en: {
    influencers: {
      titles: {
        manage: 'Manage Influencers',
        groups: 'Influencer Groups',
        create_group: 'Create Influencer Group',
        edit_group: 'Edit Influencer Group',
        group_details: 'Group Details',
        select: 'Select Influencer',
        add_group: 'Add Group',
        included_projects: 'Projects Using Group',
        excluded_projects: 'Projects Using Group',
        tier_import_projects: 'Projects Using Group for Tier Import',
        restricted_projects: 'Restricted Projects',
        associated_projects: 'Associated Projects',
        included_groups: 'Influencer Groups included in The Project',
        excluded_groups: 'Influencer Groups excluded in The Project',
        tier_groups: 'Influencer Groups Used for Tiers Import',
        restricted_groups: 'Private or Restricted Influencer Groups',
      },
      buttons: {
        new_group: 'New Group',
        add_influencer: 'Add Influencer',
        add_to_group: 'Add Influencer To The Group',
        adding: 'Adding...',
        back: 'Back',
        cancel: 'Cancel',
        close: 'Close',
        save: 'Save Group',
        submit: 'Submit',
        update: 'Update Results',
        remove: 'Remove',
        edit: 'Edit',
        delete: 'Delete',
        delete_influencer: 'Remove Influencer',
        restore_influencer: 'Restore Influencer',
        add_project: 'Add Project',
        add: 'Add',
        import_influencer: 'Import Influencers',
        export_influencer: 'Export Influencers',
      },
      labels: {
        group_name: 'Group Name',
        description: 'Description',
        social_channel: 'Social Channel',
        permission_level: 'Permission Level',
        search: 'Search influencers...',
        search_by: 'Search By',
        first_name: 'First Name',
        last_name: 'Last Name',
        handle: 'Handle',
        country: 'Country',
        provider: 'Social Network',
        status: 'Status',
        total_influencers: 'Total Influencers',
        actions: 'Actions',
        select_provider: 'Select Social Network',
        select_project: 'Select Project',
        include_groups: 'Include Groups',
        exclude_groups: 'Exclude Groups',
        select_group: 'Select Group',
        group_option: '{name} ({count} influencers)',
        active_status: 'Active Status',
        inactive_status: 'Inactive Status',
      },
      placeholders: {
        group_name: 'Enter group name',
        description: 'Enter group description',
        select_channel: 'Select a channel',  
        select_permission: 'Select permission level',
        select_country: 'Select Country',
        select_provider: 'Select Social Network',
        search: 'Search by name',
        search_project: 'Search projects...',
        select_include_groups: 'Select groups to include...',
        select_exclude_groups: 'Select groups to exclude...',
        search_groups: 'Search groups...',
        first_name_placeholder: 'User name or profile name',
      },
      messages: {
        no_results: 'No influencers found',
        no_providers: 'No social networks, Please add a social network',
        selected: 'Selected', 
        multiple_selected: '{count} Selected',
        confirm_delete: 'Are you sure you want to delete this group?',
        confirm_remove: 'Are you sure you want to remove this influencer from the group?',
        group_created: 'Group created successfully!',
        group_updated: 'Group updated successfully!',
        group_deleted: 'Group deleted successfully!',
        influencer_added: 'Influencer social network added to group successfully',
        influencer_removed: 'Influencer social network removed from group',
        influencer_updated: 'Influencer updated successfully',
        error_create: 'Failed to create group',
        error_update: 'Failed to update group',
        error_delete: 'Failed to delete group',
        error_add: 'Failed to add influencer to group',
        error_remove: 'Failed to remove influencer from group',
        error_update_influencer: 'Failed to update influencer',
        delete_success: 'Group deleted successfully!',
        delete_error: 'Failed to delete group',
        request: {
          error: 'An error occurred. Please try again.'
        },
        create: {
          success: 'Successfully created',
          error: 'Failed to create'
        },
        update: {
          success: 'Successfully updated',
          error: 'Failed to update'
        },
        delete: {
          success: 'Successfully deleted',
          error: 'Failed to delete'
        },
        import: {
          success: 'Successfully imported',
          error: 'Failed to import'
        },
        export: {
          success: 'Successfully exported', 
          error: 'Failed to export'
        },
        project: {
          added: 'Project added successfully',
          updated: 'Project updated successfully',
          removed: 'Project removed successfully',
          error_add: 'Failed to add project',
          error_remove: 'Failed to remove project',
        },
        groups_updated: 'Groups updated successfully'
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        loading: 'Loading...',
      },
      tooltips: {
        edit: 'Edit',
        delete: 'Delete', 
        remove: 'Remove from Group',
        view: 'View Details',
        include_groups: 'Select influencer groups to include in the project',
        exclude_groups: 'Select influencer groups to exclude from the project'
      },
      form: {
        steps: {
          basic_info: 'Basic Info',
          social_accounts: 'Social Accounts'
        },
        fields: {
          platform: 'Social Network',
          handle: 'Handle',
          profile_image: 'Profile Image',
          profile_name: 'Profile Name'
        },
        actions: {
          save_next: 'Save & Next',
          skip_to_next: 'Skip to Next',
          next: 'Next',
          create: 'Create',
          update: 'Update',
          add_account: 'Add Account',
          remove_account: 'Remove'
        },
        validation: {
          required: '{field} is required',
          invalid_url: 'Invalid URL format',
          name_required: 'Group name is required',
          channel_required: 'Social channel is required',
          permission_required: 'Permission level is required',
          handle_validation_msg: 'Handle must not have spaces or less than 2 characters',
        },
        titles: {
          add: 'Add Influencer',
          edit: 'Edit Influencer', 
          basic_info: 'Basic Information',
          social_accounts: 'Social Media Accounts',
          page: 'Influencer Groups', 
          new_group: 'New Group'
        },
        labels: {
          platform: 'Social Network',
          handle_username: 'username',
          profile_image: 'Profile Image',
          social_channel: 'Social Channel',
          group_name: 'Group Name',
          description: 'Description',
          permission_level: 'Permission Level',
          active: 'Active'
        },
        placeholders: {
          first_name: 'First name',
          last_name: 'Last name',
          search: 'Search influencers...',
          group_name: 'Enter group name',
          description: 'Enter group description',
          select_channel: 'Select a channel',
          select_permission: 'Select permission level',
          select_country: 'Select Country',
          select_provider: 'Select Social Network'
        },
        buttons: {
          back: 'Back',
          save_next: 'Save & Next',
          skip_to_next: 'Skip to Next',
          next: 'Next',
          create: 'Create',
          update: 'Update',
          save: 'Save',
          cancel: 'Cancel',
          close: 'Close',
          add_account: 'Add Account',
          import: 'Import',
          export: 'Export',
          update_results: 'Update Results'
        },
        errors: {
          required: '{field} is required',
          invalid_url: 'Invalid URL format'
        },
      },
      table: {
        columns: {
          profile_image: 'User Image',
          first_name: 'First Name', 
          last_name: 'Last Name',
          providers: 'Social Networks',
          country: 'Country',
          status: 'Status',
          actions: 'Actions',
          group_name: 'Group Name',
          description: 'Description',
          total_influencers: 'Total Influencers',
          project_name: 'Project Name',
        },
        status: {
          active: 'Active',
          inactive: 'Inactive'
        },
        empty: 'No influencers found',
        remove_provider: 'Remove Social Network',
      },
      filters: {
        search_by: {
          first_name: 'First Name',
          last_name: 'Last Name', 
          handle: 'Handle',
          country: 'Country',
          provider: 'Social Network',
          status: 'Status',
          active: 'Active',
          inactive: 'Inactive'
        },
        search_placeholder: 'Search by name',
        all_countries: 'All Countries',
        all_media_types: 'All Media Types',
        all_status: 'All Status',
        active: 'Active',
        inactive: 'Inactive'
      },
      modals: {
        select_group: {
          title: 'Select Group',
          search_placeholder: 'Search groups...',
          no_groups: 'No groups found',
          selected_groups: '{count} groups selected'
        },
        select_provider: {
          title: 'Select Social Network',
          description: 'Select a social network from the list below.',
          search_placeholder: 'Search social networks...',
          no_providers: 'No social networks found, Please add a social network first',
          selected_providers: '{count} social networks selected'
        },
        delete_group: {
          title: 'Delete Group',
          search_placeholder: 'Search groups...',
          no_groups: 'No groups found',
          selected_groups: '{count} groups selected'
        },
        delete: {
          title: 'Delete Group',
          message: 'Are you sure you want to delete this group?'
        },
        delete_influencer: {
          title: 'Remove this Influencer?',
          message: 'This will deactivate the Influencer across all associated groups and projects. You can reactivate them later if needed.'
        },
        restore_influencer: {
          title: 'Restore this Influencer?',
          message: 'Restoring will reactivate the Influencer and make them available again in all groups and projects.'
        },
        remove_from_group: {
          title: 'Remove Influencer',
          message: 'Are you sure you want to remove this influencer from the group?'
        },
        remove_provider_from_influencer: {
          title: 'Remove Influencer Social Network',
          message: 'Are you sure you want to remove this influencer social network from the group?'
        },
        add_project: {
          title: 'Add Project',
        },
        remove_project: {
          title: 'Unlink Project',
          message: 'Are you sure you want to unlink this project?'
        },
        import: {
          title: 'Import Influencers',
          description: 'Upload an Excel file containing the influencers you want to add.',
          file_columns_header: 'File should contain the following columns:',
          columns: {
            first_name: 'First Name',
            last_name: 'Last Name',
            profile_name: 'Profile Name',
            handle: 'Handle',
            provider: 'Social Network',
            email: 'Email',
            location: 'Location',
            country: 'Country'
          },
          file_format: 'File format: .xlsx, .xls, .csv',
          required: '(required)'
        },
      },
      details: {
        back: 'Back',
        overview: 'Overview',
        posts: 'Posts',
        analytics: 'Analytics',
        stats: {
          reach: 'Reach',
          impact: 'Impact',
          engagements: 'Engagements',
          followers: 'Followers',
          following: 'Following',
          posts: 'Posts',
          likes: 'Likes',
          comments: 'Comments',
        },
        social_networks: {
          label: 'Currently viewing {provider}',
          placeholder: 'Select a social network'
        },
        no_results: 'No data available',
        nobio: 'There\'s no bio available for this influencer'
      },
    }
  }
}

module.exports.influencers = influencers;